// extracted by mini-css-extract-plugin
export default {"container":"TimeIndicator_container__r6anY","icon":"TimeIndicator_icon__Sr5nE","text":"TimeIndicator_text__pUMAI"};